import React from 'react';

export const AdmissionContext = React.createContext<{form: any, claimDetailBackup: any, buddhimedForm: any}>({
  form: {},
  claimDetailBackup: {},
  buddhimedForm: {},
});
